import React, {Component} from 'react';
import {Button, Checkbox, Image} from 'react-bootstrap';
import {toastr} from 'react-redux-toastr';
import {Redirect, withRouter} from 'react-router-dom'
import {connect} from 'react-redux';

import {deleteDesigns} from './actions.js';
import {fetch_folders} from '../../views/Folders/actions';
import ContextMenu from '../contextMenu/index.js';
import ImageBox from "../../components/ImageBox";
import ShareLinkModal from '../../components/ShareLinkModal';

import './style.css';
import {MoveToFolderModal} from "../../views/Folders/commons/MoveToFolderModal";
import {DeleteDesignModal} from "../../views/Folders/commons/DeleteDesignModal";


const getSrcFromResource = (resource) => {
    const tail = '?t=' + Date.now();
    const src = resource.thumbnail ? resource.thumbnail : (resource.low_src ? resource.low_src : resource.src);
    if (!src) return '';
    if (src.indexOf('data:image') > -1 || src.indexOf('http') > -1 || src.indexOf('blob:') > -1) {
        return src;
    } else {
        return global.config.static_file_server_path + src + tail;
    }
};


const ImageContainer = React.memo(({resource, on_click}) =>
    <Image
        className="unselectable"
        onClick={() => on_click(resource)}
        src={getSrcFromResource(resource)}
        style={{
            border: 'none',
            height: 256,
            borderRadius: 6,
            padding: 0,
            boxShadow: '0 0 8px 0 rgba(66,66,66,0.5)',
            cursor: 'pointer'
        }}
    />
);

class DesignsPanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            base_id: Math.floor(Math.random() * 10000000000),
            selectedDesigns: [],
            activeDesign: null,
            show_share_modal: false,
        };
    }

    handleDesignSelection = (e, selectedDesign) => {
        if (e.target.checked) {
            this.setState({
                selectedDesigns: this.state.selectedDesigns.concat([selectedDesign._id])
            })
        }
        else {
            this.setState(prevState => ({
                selectedDesigns: [...prevState.selectedDesigns].filter(elem => elem !== selectedDesign._id)
            }))
        }
    };

    showMoveToFolderModal = () => {
        fetch_folders()
            .then(data => data.json())
            .then(data => this.setState({
                folders: data.data,
                displayFolderModal: true
            }))
            .catch(error => {
                console.error(error);
                toastr.error("Something went wrong :/");
            })
    };

    setActiveDesign = (design_id) =>
        this.set_state({
            activeDesign: design_id
        });

    set_state = async state => new Promise(resolve => this.setState(state, resolve));

    GenerateContextMenu = ({design}) => (
        <ContextMenu contextMenuName="your-designs-context-menu" contextMenuOptions={[
            {
                'name': 'Move to Folder',
                'action': (e => {
                    this.setActiveDesign(design._id)
                        .then(() => this.showMoveToFolderModal())
                })
            },
            {
                'name': 'Delete',
                'action': (e => {
                    this.setActiveDesign(design._id)
                        .then(() => this.setState({'displayDeleteDesignModal': true}))
                })
            },{
                name: 'Share',
                action: e => {
                    e.stopPropagation();
                    this.setActiveDesign(design._id)
                    .then(() => this.setState({'show_share_modal': true}))
                    // this.activate_share_modal({ design_id: design._id, is_saved_design: true });
                }
            }
        ]}/>
    );

    SavedDesignContainer = ({i, this_as_param}) => (
        <div style={{
            margin: 10,
            position: 'relative',
            display: 'inline-block',
        }}>
            <div key={'all_designs_rsc_thumbnail' + i} className="saved-design-thumbnails">
                {!(this_as_param.state.selectedDesigns.length >= 1) ?
                    <this_as_param.GenerateContextMenu design={this_as_param.props.resources[i]}/> : null}
                <Checkbox id={'design-checkbox-' + this_as_param.props.resources[i]._id}
                          className={this_as_param.state.selectedDesigns.length ? "multiselect-input-xyz design-multiselect-checkbox-show" : "multiselect-input-xyz design-multiselect-checkbox"}
                          onChange={(e) => this_as_param.handleDesignSelection(e, this_as_param.props.resources[i])}
                />
                {/* <ImageContainer resource={this_as_param.props.resources[i]} on_click={this_as_param.props.on_click}/> */}
                <ImageBox
                    key={'saved-designs-dashboard' + i}
                    idx={i}
                    image_src={global.config.static_file_server_path + this_as_param.props.resources[i].thumbnail + '?t='+Date.now()}
                    name={this_as_param.props.resources[i].name}
                    disable_overlay={true}
                    image_style={{
                        maxWidth: 148,
                        maxHeight: 173,
                        height: 'unset',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        objectFit: 'contain',
                        display: 'block',
                        boxShadow: '0 0 8px 0 rgba(66,66,66,0.5)'
                    }}
                    container_style={{width: 165}}
                    footer_text={this_as_param.props.resources[i].name}
                    on_click={() => this_as_param.props.on_click(this_as_param.props.resources[i])}
                    skeleton={true}
                    skeleton_width={160}
                    skeleton_height={185}
                    boxed_view={true}
                    max_container_height={185}
                />
            </div>
            {/* <h6><b>{this_as_param.props.resources[i].name}</b></h6> */}
        </div>
    );

    DesignResourceThumbnails = () => (
        <div>
            {this.props.resources.map((element, index) => <this.SavedDesignContainer i={index} this_as_param={this}/>)}
        </div>
    );

    deleteDesigns = () => {
        deleteDesigns(this.state.activeDesign ? this.state.activeDesign : this.state.selectedDesigns)
            .then(() => {
                let checkBoxesInput = document.getElementsByClassName("multiselect-input-xyz");
                for (let item of checkBoxesInput) {
                    item.children[0].children[0].checked = false;
                }
                this.setState({
                    displayDeleteDesignModal: false,
                    selectedDesigns: [],
                    activeDesign: null
                })
            })
            .then(() => this.props.refreshDesigns())
            .catch(() => toastr.error('Oops something went wrong :/. Please try later.'))
    };


    render() {
        if (this.props.resources.length === 0) {
            return <div/>
        }
        return (
            <React.Fragment>
                <ShareLinkModal 
                    show_share_modal={this.state.show_share_modal}
                    hide_share_modal={() => this.setState({ show_share_modal: false, activeDesign: null })}
                    design_id={this.state.activeDesign}
                    is_saved_design
                />
                <MoveToFolderModal show={this.state.displayFolderModal}
                                   onHide={() => this.setState({displayFolderModal: false, activeDesign: null})}
                                   folders={this.state.folders} omitFolders={this.props.user?[this.props.user.my_designs_folder]:[]} activeDesign={this.state.activeDesign ? this.state.activeDesign : this.state.selectedDesigns}/>
                <DeleteDesignModal show={this.state.displayDeleteDesignModal}
                                   onHide={() => this.setState({displayDeleteDesignModal: false, activeDesign: null})}
                                   deleteOnClick={this.deleteDesigns}/>
                <div style={{marginTop: 50, marginBottom: 25}}>
                    <span style={{fontSize: 28, fontWeight: 'bold'}}>All your designs</span>
                    <Button style={{float: 'right', marginRight: 30}}
                            className={this.state.selectedDesigns.length === 0 ? "multiselect-options" : "btn btn-orange"}
                            onClick={() => this.setState({displayDeleteDesignModal: true})}><span
                        className="fa fa-trash-alt"/></Button>
                    <Button style={{float: 'right', marginRight: 5}}
                            className={this.state.selectedDesigns.length === 0 ? "multiselect-options" : "btn btn-orange"}
                            onClick={this.showMoveToFolderModal}><span className="fa fa-folder"/></Button>
                </div>
                <this.DesignResourceThumbnails/>
            </React.Fragment>
        )
    }
}

const mapStateToProps = function(state) {
    return {
        user: state.user,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DesignsPanel))